module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [(_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "12px"
    },
    attrs: {
      "lg8": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" If the locations are not displaying on\n              the CTA form in the app check that the upper location has been setup in the database with a parent of 0.\n                    ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5\t",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncAddRegion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Create Region")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5\t",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadRegions.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("REGIONS")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}